import { useState } from 'preact/hooks';
import { CalendarCheck, Check, Gift } from 'lucide-preact';
import type { RewardBundle } from '@vm/shared';
import { DAILY_LOGIN_REWARDS, dailyLoginReward } from '@vm/content';
import { claimDaily } from '../state/actions';
import { catalog, me } from '../state/store';
import { AsyncButton, Modal, RewardChips } from '../ui/kit';
import { Confetti } from './Results';

export function DailyLogin(props: { close: () => void }) {
  const d = me.value?.dailyLogin;
  const [claimed, setClaimed] = useState<RewardBundle | null>(null);
  if (!d) return null;
  // The cycle is live-configurable (catalog); the built-in one until the catalog loads.
  const cycle = catalog.value?.dailyLogin?.length ? catalog.value.dailyLogin : DAILY_LOGIN_REWARDS;
  const n = cycle.length;
  const today = ((Math.max(1, d.day) - 1) % n) + 1;
  return (
    <Modal title="Daily Supply Drop" icon={<CalendarCheck size={22} />} size="lg" onClose={props.close} class="daily">
      {claimed && <Confetti count={36} />}
      <p class="muted center">Log in every day for bigger drops. Day {n} is the jackpot!</p>
      <div class="daily-track">
        {Array.from({ length: n }, (_, i) => {
          const day = i + 1;
          const past = day < today || (day === today && (d.claimedToday || !!claimed));
          const isToday = day === today;
          return (
            <div key={day} class={`daily-day ${past ? 'is-past' : ''} ${isToday ? 'is-today' : ''} ${day === n ? 'is-big' : ''}`}>
              <span class="daily-label">Day {day}</span>
              <span class="daily-art">
                {past ? <Check size={30} strokeWidth={4} /> : <Gift size={day === n ? 40 : 30} />}
              </span>
              <RewardChips reward={isToday ? claimed ?? (d.claimedToday ? dailyLoginReward(day, cycle) : d.nextReward) : dailyLoginReward(day, cycle)} class="daily-reward" />
            </div>
          );
        })}
      </div>
      <div class="ui-modal-actions center">
        {claimed || d.claimedToday ? (
          <button class="btn primary big" onClick={props.close}>
            {claimed ? 'Sweet!' : 'Come back tomorrow'}
          </button>
        ) : (
          <AsyncButton
            class="primary big"
            onClick={async () => {
              const r = await claimDaily();
              if (r) setClaimed(r);
            }}
          >
            <Gift size={22} /> Claim day {today}
          </AsyncButton>
        )}
      </div>
    </Modal>
  );
}
